import store from './LocalStorageHelper';

/**
 * To trigger the data layer push, a HTMLElement containing the data attributes
 * - data-consent-name: for CookieConsent check e.g. "consent-type-statistics"
 * - data-layer-helper-push-id: corresponding id from the sent form (must be the same)
 * is mandatory on the successpage for the sent form.
 * Example
 * Page register:
 * <form ... data-layer-helper-form-id="newsletter-register"
 *      data-layer-helper-form-title="2 RTH - NL-Verwaltung: Anmeldung">...</form>
 * Page success:
 * <div data-consent-name="consent-type-statistics" data-layer-helper-push-id="newsletter-register">
 *     <!-- ID must match corresponding form to push to the dataLayer --></div>
 */

export default class DataLayerHelper {
    init() {
        this.consentNameAttribute = 'data-consent-name';
        // Form data attributes
        this.identifierAttribute = 'data-layer-helper-form-id';
        this.titleAttribute = 'data-layer-helper-form-title';
        // Pusher data attributes
        this.pusherIdentifier = 'data-layer-helper-push-id';
        // Store key
        this.storeFormIdentifier = 'dataLayerFormIds';

        const forms = document.querySelectorAll(`[${this.identifierAttribute}]`);
        const pushIdentifier = document.querySelectorAll(`[${this.pusherIdentifier}]`);

        for (const form of forms) {
            this.clearAndBind(form);
        }

        for (const pusher of pushIdentifier) {
            this.pushTag(pusher);
        }

        // Clear all
        store.remove(this.storeFormIdentifier);
    }

    /**
     * Push datalayer and remove ID from localstorage
     * @param {HTMLElement} pusher
     */
    pushTag(pusher) {
        const id = pusher.getAttribute(this.pusherIdentifier);
        const formData = store.get(this.storeFormIdentifier);

        if (formData[id]) {
            window.dataLayer.push({
                event: 'formSubmission',
                formId: id,
                formTitle: formData[id].title,
            });

            this.clear(id);
        }
    }

    /**
     * Clear previously attached ids and bind setter to form submit
     * @param {HTMLElement} form
     */
    clearAndBind(form) {
        // Clear
        const { id } = this.clear(null, form);

        // Add event to add id
        form.addEventListener('submit', () => {
            const formIds = store.get(this.storeFormIdentifier) || {};

            formIds[id] = {
                title: form.getAttribute(this.titleAttribute) || '',
            };

            store.set(this.storeFormIdentifier, formIds);
        });
    }

    /**
     * Clear formId data from storage
     *
     * @param {string} locId
     * @param {object} form
     * @returns
     */
    clear(locId = null, form = null) {
        const formIds = store.get(this.storeFormIdentifier);

        let id = locId;
        if (!id) id = form.getAttribute(this.identifierAttribute);

        if (formIds) {
            delete formIds[id];
            store.set(this.storeFormIdentifier, formIds);
        }

        return { formIds, id };
    }
}
